/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicoststitle2Inputs */

const en_aicoststitle2 = /** @type {(inputs: Aicoststitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI costs`)
};

const de_aicoststitle2 = /** @type {(inputs: Aicoststitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Kosten`)
};

/**
* | output |
* | --- |
* | "AI costs" |
*
* @param {Aicoststitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicoststitle2 = /** @type {((inputs?: Aicoststitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicoststitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicoststitle2(inputs)
	return de_aicoststitle2(inputs)
});
export { aicoststitle2 as "aiCostsTitle" }